import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'check-to-print',
    templateUrl: './check-to-print.gadget.html',
    styleUrls: ['./check-to-print.gadget.scss'],
    standalone: false
})
export class CheckToPrintGadget {

    @Input() key;
    @Output() notify = new EventEmitter();

    constructor(
    ) {}
}
